exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".action-link[data-v-63ad679b]{cursor:pointer}.m-b-none[data-v-63ad679b]{margin-bottom:0}", ""]);

// exports
